import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircledArrowIcon, LoaderIcon } from '@components/Icons';
import { ContactSearchModal } from '@components/Modals/ContactSearchModal';
import { useNavigate } from 'react-router-dom';
import { selectSearch, setSearchTerm } from '@actions/search';
import renderOption from '@views/CommandBar/Option';
import { useContactSearch } from '@support/hooks/use-contact-search';
import { SearchTips } from '@views/Search/Tips';
import styles from './SearchModal.module.scss';

const DummyIcon = () => null;

export default function SearchModal({ closeModal }: { closeModal: () => void }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mainSearchState = useSelector(selectSearch);
  const [_, contactSearchState] = useContactSearch({});
  const searchTerm = contactSearchState.term;

  const adjustResults = (results: any[]) => {
    if ((results || []).length === 0) {
      return results;
    }

    // @ts-ignore
    return results
      .map((contact) => ({ contact, type: 'contact' }))
      .concat({
        type: 'cta',
        title: 'See all results',
        inlineIcon: CircledArrowIcon,
      });
  };

  const noOptionsNodes = () => {
    let noOptionsMessage = 'Search your network.';
    let noOptionsIcon = <DummyIcon />;

    if (searchTerm !== '') {
      noOptionsMessage = 'No results found.';
    }

    if (contactSearchState.results.isFetching) {
      noOptionsMessage = 'Searching your network...';
      noOptionsIcon = <LoaderIcon width={12} height={12} />;
    }

    return { noOptionsMessage, noOptionsIcon };
  };

  const onOptionSelected = (contact) => {
    if (contact.type === 'cta') {
      dispatch(setSearchTerm(searchTerm));
      closeModal();
      navigate('/search');
      return;
    }

    navigate(`/contact/${contact?.contact.id}`);
  };

  return (
    <ContactSearchModal
      isOpen={true}
      closeModal={closeModal}
      contactIsSelected={() => false}
      defaultContactSearchTerm={mainSearchState.term}
      adjustResults={adjustResults}
      onOptionSelected={onOptionSelected}
      placeholder="Search your network"
      beforeOptions={searchTerm && `Search Results for "${searchTerm}"`}
      noOptionsNodes={noOptionsNodes}
      renderNonContactOption={renderOption}
      afterOptions={!searchTerm && <SearchTips className={styles.searchTips} />}
      useMainSearchSorting
    />
  );
}
